import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'sa-input-textarea',
  templateUrl: './sa-input-textarea.component.html',
  styleUrls: ['./sa-input-textarea.component.scss']
})
export class SaInputTextareaComponent implements OnInit {
  @Input() text = "";
  @Input() title = "";
  @Input() required = "none"; // P.S. can be 'text' (if required) or 'none' if not required
  @Input() rows = 3;

  @Output() textChange = new EventEmitter();
  @Output() hasChanged = new EventEmitter();

  isValid = true;
  tiClass = { 'border': 'solid 1px gray' }; // {'background-color':'green'};
  constructor() { }
  ngOnInit(): void {

  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewChecked() {
    this.doValidation(this.text);
  }
  change(newValue: any) { // P.S. newValue has the changed text
    this.doValidation(newValue);
    this.text = newValue;

    // P.S. Synchronize the text with the model of the parent
    this.textChange.emit(newValue);
    // P.S. send the parent the message whether validation is true or false
    this.hasChanged.emit(this.isValid);
  };

  doValidation (newValue: string) {
    // P.S. implement your validation rules here
    if (this.required == 'text') {
      if (!newValue || newValue == '') {
        this.isValid = false;
        this.tiClass = { 'border': 'solid 2px red' };
      } else {
        this.isValid = true;
        this.tiClass = { 'border': 'solid 1px gray' };
      }
    }
  };

}
